module.exports = __webpack_public_path__ + "static/img/14000398.30b273f9.png";